import classnames from 'classnames';
import { useProgressTimer } from 'hooks/useProgressTimer';
import { FC } from 'react';

interface RemainingTimeBadgePros {
  className?: string;
  createAtMilliseconds?: number;
  windowInMilliseconds?: number;
}

export const RemainingTimeBadge: FC<RemainingTimeBadgePros> = ({
  className,
  createAtMilliseconds = -1,
  windowInMilliseconds = -1,
}) => {
  const { remainingTimeInSeconds } = useProgressTimer(createAtMilliseconds, windowInMilliseconds);
  const display = getDisplayTime(remainingTimeInSeconds);

  if (display === '') {
    return null;
  }

  return (
    <span
      data-e2e="remaining-time-badge"
      className={classnames('badge badge-dismissible rounded-pill badge-outline', className)}
    >
      {display}
    </span>
  );
};

function getDisplayTime(remainingTimeInSeconds: number) {
  const minute = Math.floor(remainingTimeInSeconds / 60);
  const second = remainingTimeInSeconds - minute * 60;

  if (minute > 0) {
    return `${minute}m`;
  }

  if (second > 0) {
    return `${second}s`;
  }

  return '';
}
